const classIsActive = require("./class-is-active");

module.exports = (elem) => {
    if(classIsActive(elem)) return;
    elem.classList.add("is-active");

    return elem;
};
